import { CrossSVG } from '@sbercloud/uikit-product-icons';
import { ButtonFunction } from '@snack-uikit/button';
import React from 'react';
import { useAnalytics } from 'src/hooks/useAnalytics';
import { MarketplaceCategory } from 'src/types/marketplace';
import { ChipsFilterRow } from 'src/uikit/ChipsFilterRow';

import s from './MarketplaceCategoryBlock.module.scss';

const MocksRu = {
  category: 'Категория',
  reset: 'Сбросить',
};

export type MarketplaceCategoryBlockProps = {
  onChange: (newCategory: string) => void;
  categories: MarketplaceCategory[];
  currentCategory: string;
};

export function MarketplaceCategoryBlock({
  onChange,
  categories,
  currentCategory,
}: MarketplaceCategoryBlockProps) {
  const { clickAnalytics } = useAnalytics();

  return (
    <div className={s.root}>
      <div className={s.filterTitle}>
        <h4>{MocksRu.category}</h4>

        {currentCategory && (
          <ButtonFunction
            label={MocksRu.reset}
            appearance="neutral"
            size="s"
            icon={<CrossSVG />}
            onClick={() => {
              clickAnalytics({
                action: 'click',
                clickZone: 'body',
                clickElement: 'button',
                clickContent: MocksRu.reset,
                uniqueId: 'marketplace-filter-category-reset',
                transitionType: 'inside-link',
              });

              onChange(currentCategory);
            }}
          />
        )}
      </div>

      <ChipsFilterRow
        chips={categories.map((c) => ({
          id: c.slug || '',
          label: c.displayName,
        }))}
        onClick={onChange}
        defaultActive={currentCategory}
      />
    </div>
  );
}
